<div class="main-content">
  <div class="container-fluid p-0">
    <div class="row">
      <div class="col-md-12">
        <span class="pull-left py-3">
          <h2 class="text-purple-manax m-0 pl-3 title-section">Notas y adjuntos</h2>
          <p class="d-none d-sm-inline text-purple-manax pl-3">Listado de notas y adjuntos de cada trabajo</p>
        </span>
        <span class="pull-right py-3 pr-3">
          <button (click)="openHelpVideoModal()" class="btn btn-outline-manax p-2 ml-2">
            <i class="material-icons align-middle">play_circle</i>&nbsp;<span class="d-none d-sm-inline">Tutorial</span>
          </button>
        </span>

        <table class="table table-hover m-0 align-top" matSort (matSortChange)="sortTaskComments($event)" stickyHeader
          stickyFooter>

          <thead class="text-manax">
            <tr>

              <!-- All -->
              <th class="d-none d-md-table-cell p-0 pl-2">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection()"
                      [checked]="selection.all">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </th>

              <!-- PC -->
              <th class="d-none d-md-table-cell align-top">
                Cliente<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.client"
                  placeholder="Buscar por Cliente…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Trabajo<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.task"
                  placeholder="Buscar por Trabajo…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Fecha<br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.createdAtStart"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" /><br>
                <input type="date" class="filter small" [(ngModel)]="filter.filters.createdAtEnd"
                  (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 120px;" />
              </th>
              <th class="d-none d-md-table-cell align-top">
                Trabajador<br>
                <input type="text" class="filter small" [(ngModel)]="filter.filters.worker"
                  placeholder="Buscar por Trabajador…" (ngModelChange)="lazySearch()" (click)="$event.stopPropagation()"
                  (keydown.space)="$event.stopPropagation()" style="max-width: 1000px;" />
              </th>
              <th class="d-none d-md-table-cell align-top" style="max-width: 300px;">
                Nota
              </th>
              <th class="d-none d-md-table-cell align-top">
                <i class="material-icons">attach_file</i>
              </th>

              <!-- Mobile -->
              <!-- <th class="d-table-cell d-md-none">
                Orden por: <span class="ml-2">{{sortOptions[filter.sort] || 'ninguno'}}</span>
                <span class="text-manax pull-right cursor-pointer" *ngIf="filtered"> - Filtrada - </span>
              </th> -->

              <!-- All -->
              <th class="d-none d-md-table-cell td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">

                  <!-- sort order -->
                  <button mat-menu-item class="d-block d-md-none" [matMenuTriggerFor]="order">
                    <span>Orden</span>
                  </button>

                  <!-- filters -->
                  <!--button mat-menu-item class="d-block d-md-none" (click)="openFilter()">
                          <span>Filtros</span>
                        </button-->
                  <button mat-menu-item (click)="clearFilter()">
                    <span>Limpiar Filtros</span>
                  </button>
                  <button mat-menu-item (click)="exportTaskComments()">
                    <span>Exportar Listado</span>
                  </button>
                </mat-menu>

                <mat-menu #order="matMenu">
                  <ng-container *ngFor="let key of sortOptionsKeys">
                    <button mat-menu-item (click)="sortTaskComments(key)">
                      <span>{{sortOptions[key]}}</span>
                    </button>
                  </ng-container>
                  <button mat-menu-item (click)="sortTaskComments('')">
                    <span>Sin Ordenar</span>
                  </button>
                </mat-menu>
              </th>
            </tr>
          </thead>

          <tbody>
            <!-- default: future tasks, past or current with tracking ok -->
            <!-- primary: past with tracking null or delayed, or current with tracking delayed -->
            <!-- danger: current with tracking null -->
            <tr *ngFor="let comment of comments" [class.text-danger]="comment.isDeleted">

              <!-- All -->
              <td class="d-none d-md-table-cell p-0 pl-2" (click)="$event.stopPropagation();">
                <div class="form-check m-0 mx-2">
                  <label class="form-check-label">
                    <input class="form-check-input input-sm" type="checkbox" (click)="toggleSelection(comment._id)"
                      [checked]="selection.all || selection[comment._id || '']">
                    <span class="form-check-sign">
                      <span class="check"></span>
                    </span>
                  </label>
                </div>
              </td>

              <!-- PC -->
              <td class="d-none d-md-table-cell field-container" (click)="openClientModal(comment.client)"
                *ngIf="comment.task && comment.client">
                {{comment.client.firstname}} {{comment.client.lastname}}
                <i class="material-icons small">launch</i>
              </td>
              <td class="d-none d-md-table-cell field-container" *ngIf="!comment.task || !comment.client">
                - trabajo eliminado -
              </td>

              <td class="d-none d-md-table-cell field-container" *ngIf="comment.task"
                (click)="openTaskModal(comment.task)">
                {{comment.task.title}} -
                <span *ngFor="let category of comment.task?.category">
                  {{category.name}}.&nbsp;
                </span>
                <i class="material-icons small">launch</i>
              </td>
              <td class="d-none d-md-table-cell field-container" *ngIf="!comment.task">
                - trabajo eliminado -
              </td>

              <td class="d-none d-md-table-cell">{{comment.createdAt | date:'dd/MM/yyyy HH:mm'}}</td>

              <td class="d-none d-md-table-cell field-container" (click)="comment.worker && openWorkerModal(comment.worker)">
                {{comment.worker?.firstname}} {{comment.worker?.lastname}}
                <i class="material-icons small">launch</i>
              </td>

              <td class="d-none d-md-table-cell" style="max-width: 300px;">{{comment.comment}}</td>
              <td class="d-none d-md-table-cell">
                <ng-container *ngFor="let file of comment.attachments">
                  <!-- Validar luego si es una imagen con todos sus tipos de formato o no -->
                  <img *ngIf="(file.fileUrl).substring(file.fileUrl.length - 3) !== 'pdf'" class="image-preview cursor-pointer" [src]="file.fileUrl" (click)="openFile(file)" />
                  <img *ngIf="(file.fileUrl).substring(file.fileUrl.length - 3) == 'pdf'"  class="image-preview cursor-pointer"  src="/assets/img/pdf-image.png" (click)="openPdf(file)"/>
                </ng-container>
              </td>

              <!-- Mobile -->
              <td class="d-table-cell d-md-none" style="line-height: 14px;">
                <div class="col-12">
                  <div class="row">
                    <div class="col-4">
                      <div class="row mb-2 pr-3">
                        <b class="bold-item">
                          {{comment.worker?.firstname}} {{comment.worker?.lastname}}
                        </b>
                      </div>
                      <div class="row mb-2 pr-3">
                        {{comment.createdAt | date:'dd/MM/yyyy'}} a las {{comment.createdAt | date:'HH:mm'}}
                      </div>
                      <div class="row mb-2 pr-3">
                        Cliente: {{comment.client?.firstname}} {{comment.client?.lastname}}
                      </div>
                      <div class="row pr-3">
                        Trabajo: {{comment.task?.title}}
                      </div>
                    </div>
                    <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row pl-3">
                        {{comment.comment}}
                      </div>
                    </div>
                    <div class="col-4 d-flex flex-column align-items-center justify-content-center p-0">
                      <div class="row pl-3">
                        <ng-container *ngFor="let file of comment.attachments">
                          <img class="image-preview cursor-pointer" [src]="file.fileUrl" (click)="openFile(file)" />
                        </ng-container>
                      </div>
                    </div>
                  </div>
                </div>
              </td>

              <!-- All -->
              <td class="td-actions text-right p-0">
                <button mat-icon-button type="button" class="btn btn-default btn-link btn-just-icon"
                  [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
                  <i class="material-icons">more_vert</i>
                </button>
                <mat-menu #menu="matMenu">
                  <button mat-menu-item (click)="openDeleteTaskCommentConfirm(comment, true)" *ngIf="isDev">
                    <span>Eliminar</span>
                  </button>
                </mat-menu>
              </td>
            </tr>

            <!-- All -->
            <tr *ngIf="thereAreMore && !loading">
              <td colspan="10">
                <button class="btn btn-link text-purple-manax text-capitalize p-0" (click)='loadMore()'>+ cargar
                  mas</button>
              </td>
            </tr>
            <tr *ngIf="loading">
              <td colspan="10" class="text-center">
                <div class="d-flex justify-content-center" >
                  <div class="spinner-border" role="status">
                    <span class="sr-only">Loading...</span>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
          <tfoot class="text-purple-manax">
            <tr *ngIf="!loading">
              <td colspan="10" class="text-left p-0 py-2 pl-3">Mostrando: {{ comments.length }} comentarios</td>
            </tr>
          </tfoot>
        </table>
        <div class="row" *ngIf="totalMoreMinTutorial && !loading">
          <div class="col-12 video-responsive">
            <iframe [src]="safeSrc" title="YouTube video player" frameborder="0"
              allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              allowfullscreen></iframe>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>